export const cepci_item = [
    
    {
      
        "url": "/pdf/CEPCI/Codigo_Conducta_OM.pdf",
        "icono": "1cepci.png"
    },
    {
     
        "url": "/pdf/CEPCI/Codigo_Etica_Hidalgo.pdf",
        "icono": "2cepci.png"
    },
    {
     
        "url": "/pdf/CEPCI/Protocolo_y_Procedimiento_a_Denuncias.pdf",
        "icono": "4cepci.png"
    },
   

]

export const cepci_item2= [
  {
   
      "url": "/assets/imgs/Integrantes.jpg",
      "icono": "3cepci.png",
      "id": "Integrantes del Comité de Ética y Prevención de Conflictos de Intéres"
  },
]
